export const ZONE_SIZE_OPTIONS = [0.05, 0.1, 0.15, 0.2, 0.3];
export const ZONE_SIZE_DEFAULT = 0.1;
/**
 * Reduction du cote de la zone par categorie d'image, appliquee par-dessus le
 * reglage de partie. « Cubes » (6) et « Peinture » (7) sont nettement plus durs
 * a retoucher que les autres : la zone y est donc plus petite. Le facteur porte
 * sur le COTE du carre (0.5 = cote moitie moindre). Une categorie absente garde
 * la taille du reglage.
 */
export const ZONE_SCALE_BY_CATEGORY = {
    6: 0.75,
    7: 0.5,
};
/** Cote effectif de la zone pour une categorie, reglage de partie compris. */
export function zoneSideFor(size, category) {
    // Arrondi : 0.1 * 0.75 vaut 0.07500000000000001, valeur qui finirait telle
    // quelle dans botDrawings.json et dans les journaux.
    return Math.round(size * (ZONE_SCALE_BY_CATEGORY[category] ?? 1) * 1e6) / 1e6;
}
/**
 * Une retouche enregistree (bot) vaut pour le cote de zone sur lequel elle a
 * ete dessinee. Ses traits sont relatifs a la zone : rejouee dans un carre
 * d'une autre taille, elle serait mise a l'echelle et ne collerait plus au
 * tableau. Changer la reduction d'une categorie invalide donc ses retouches.
 */
export function isZoneSideFor(recorded, category) {
    return Math.abs(recorded - zoneSideFor(ZONE_SIZE_DEFAULT, category)) < 1e-9;
}
export function isZoneSize(value) {
    return typeof value === 'number' && ZONE_SIZE_OPTIONS.includes(value);
}
function clamp(value, min, max) {
    if (!Number.isFinite(value))
        return min;
    return value < min ? min : value > max ? max : value;
}
/**
 * Carre effectif de cote `size`, ancre sur (zone.x, zone.y) et ramene dans
 * l'image si besoin. Le resultat est toujours entierement contenu dans [0,1]².
 */
export function resolveZone(zone, size) {
    // Une taille aberrante ne doit pas produire un rect hors image : on la borne
    // avant tout calcul.
    const side = clamp(size, 0, 1);
    return {
        x: clamp(zone.x, 0, 1 - side),
        y: clamp(zone.y, 0, 1 - side),
        width: side,
        height: side,
    };
}
//# sourceMappingURL=zone.js.map